import { useQuery } from "@tanstack/react-query";
import { Inbox } from "@/api/assistant";

/** The inbox review state. Polls while a review is running so its proposals
 *  appear as soon as it finishes. */
export function useInbox() {
  return useQuery({
    queryKey: ["inbox"],
    queryFn: Inbox.state,
    refetchInterval: (q) => (q.state.data?.review?.status === "running" ? 3000 : false),
  });
}
